var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16H16V256H256V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 256H16V496H256V256Z",
    fill: "#2980B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H256V256H496V16Z",
    fill: "#E32D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H256V496H496V256Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.533 192.241L136.267 161.73L98.3367 191.617L116.147 147.698L76.0019 120.859L123.275 124.226L136.395 77.7525L147.801 123.753L196.054 121.869L155.83 146.931L172.533 192.241Z",
    fill: "#2980B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M412.505 433.244L376.239 402.733L338.309 432.62L356.119 388.701L315.974 361.862L363.247 365.229L376.367 318.755L387.773 364.755L436.026 362.872L395.802 387.934L412.505 433.244Z",
    fill: "#E32D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPa);
export default __webpack_public_path__ + "static/media/PA.04821ca184cba99be8890552f51ca066.svg";
export { ForwardRef as ReactComponent };